'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var removeTags = function removeTags(string) {
  return string.replace(/(<([^>]+)>)/gi, ' ').replace(/ *(\n+) */g, '$1').replace(/ ([,.;:!])/g, '$1').trim();
};

var removeConsecutiveWhitespace = function removeConsecutiveWhitespace(string) {
  return string.replace(/\s\s+/g, ' ').trim();
};

var removeConsecutiveSpaces = function removeConsecutiveSpaces(string) {
  return string.replace(/ {2,}/g, ' ').trim();
};

var stripTags = exports.stripTags = function stripTags() {
  var htmlString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var preserveNewlines = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return preserveNewlines ? removeConsecutiveSpaces(removeTags(htmlString.replace(/(<\/[p|h1-6]>)\s*(<[p|h1-6]>)/gim, '$1\n\n$2'))) : removeConsecutiveWhitespace(removeTags(htmlString));
};